// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 1992) return "js/vendors-cf4ed6e24cbf." + __webpack_require__.h() + ".js";
  // return url for filenames based on template
  return "js/" + {2714: "shared-3128ce2108c0",3145: "schedule-report-dialog",5955: "user-report-dialog",}[chunkId] + "." + __webpack_require__.h() + ".chunk.js"
}